import { gql } from '@apollo/client'

export default gql(`
query listFolders ($limit: Int, $offset: Int, $order: String , $orderBy: String $project: String $filter: ListFolderFilterInput){
    listFolders(
        limit: $limit
        offset: $offset
        order: $order
        orderBy: $orderBy
        project: $project
        filter: $filter
        ){
            items{
                id
                name
                tags{
                    key
                    name
                    type
                    module
                    assetCount
                    mediaCount
                    isTransferring
                }
                position
                createdAt
            }
            totalCount
        }
  }
`)
